




































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
const { AgGridVue } = require('ag-grid-vue');

import { fetchDias, postTarifas, MsResponseData } from './fetchData';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { split } from 'lodash';
import moment from 'moment';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    // DetalleForm,
    // TablaInfoGral,
    'ag-grid-vue': AgGridVue,
    DatePicker,
    TimePicker,
  },
})
export default class VerDetalleModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true }) detalleSeleccionado: any;
  @Prop({ required: true }) peajeSeleccionado: number;
  @Prop({ required: true }) verDetalle: boolean;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  requestsStart: number = 0;
  MsResponseData: MsResponseData = null;
  tipotarifa: string = '';
  inicio: any = null;
  fin: any = null;
  fechainicio: any = null;
  fechafin: any = null;
  precio: number = 0;
  dia: string = '';
  dias: any = [];
  dialog: boolean = false;
  confirm: boolean = false;
  mindate: any = moment().format('YYYY-MM-DD h:mm:ss a');

  tipoTarifas = [
    'TBFP - Tarifa Base Fuera de Punta',
    'TBP - Tarifa Base Punta',
    'TS - Tarifa Saturación',
    'TN - Tarifa Normal',
  ];
  // tipoTarifas = ['TBFP', 'TBP', 'TS', 'TN'];
  categorias = [
    'Auto, Auto Con Remolque, Station Wagon, Station Wagon con Remolque',
    'Bus de Dos Ejes, Camión de Dos Ejes',
    'Bus de Más de Dos Ejes, Camión de Más de Dos Ejes',
    'Moto, Motoneta',
  ];

  seleccionado: number = 0;

  handleCerrar() {
    this.$emit('cerrar');
  }

  sendData() {
    this.enviaDatos(this.peajeSeleccionado, this.detalleSeleccionado);
    // this.handleCerrar();
  }

  async enviaDatos(id_peaje: number, data: any) {
    this.MsResponseData = (await this.postTarifas(id_peaje, data)) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.$snotify.success(this.$t('mensajes.mensajesExito.editar'));
          this.$store.commit('setApplicationUptaded');
          this.handleCerrar();
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  postTarifas(id_peaje: number, data: any) {
    this.showLoading();
    return postTarifas(id_peaje, data)
      .catch(error => {
        this.$snotify.error('Error de conexión');
        return;
      })
      .finally(() => this.hideLoading());
  }

  handleShowPermisos(selected: number) {
    this.seleccionado = selected;
  }

  minfecha() {
    if (this.fechainicio == null) {
      return this.mindate;
    } else {
      console.log(moment(this.fechainicio));
      return moment(this.fechainicio);
    }
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  mounted() {
    this.buscaDias();
  }

  cambiarEstado(index: number, estado: number) {
    this.detalleSeleccionado[this.seleccionado][index]['estado'] = estado;
    if (estado == 2) {
      this.detalleSeleccionado[this.seleccionado][index]['css'] =
        'border:1px solid red;width: 97%; padding: 5%; display: flex; margin-bottom: 15px;';
    } else {
      this.detalleSeleccionado[this.seleccionado][index]['css'] =
        'width: 97%; padding: 5%; display: flex; margin-bottom: 15px;';
    }
  }

  agregarTarifa() {
    var tarifa = {
      id_peaje: this.peajeSeleccionado,
      nom_tipotarifa: split(this.tipotarifa, ' ')[0],
      val_precio: this.precio.toString(),
      val_hora_inicio: this.inicio.format('h:mm:00'),
      val_hora_fin: this.fin.format('h:mm:00'),
      nom_tipodia: this.dia,
      id_categoria: this.seleccionado + 1,
      fec_inicio_vigencia: this.fechainicio.format('YYYY-MM-DD'),
      fec_fin_vigencia: this.fechafin.format('YYYY-MM-DD'),
      id_horario: 0,
      estado: '1',
    };
    this.detalleSeleccionado[this.seleccionado].push(tarifa);
    this.tipotarifa = '';
    this.precio = 0;
    this.inicio = '';
    this.fin = '';
    this.dia = '';
  }

  async buscaDias() {
    this.MsResponseData = (await this.fetchDias()) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          for (let i = 0; i < this.MsResponseData.data.length; i++) {
            this.dias.push(this.MsResponseData.data[i].nom_tipodia);
          }
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  onDelete(index: number) {
    if (this.detalleSeleccionado[this.seleccionado][index]['estado'] == 2) {
      return "color: 'error';";
    } else {
      return;
    }
  }

  fetchDias() {
    this.showLoading();
    return fetchDias()
      .catch(error => {
        this.$snotify.error('Error');
        return;
      })
      .finally(() => this.hideLoading());
  }
}
